import React from 'react'
import { componentBoxShowAction } from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'
import { ListColumnType } from '../../../model/list'
import { ButtonType } from '../../../model/button'
import {
  DeleteMember,
  EditMember,
} from 'src/pages/collection/components/collection-page-view/components/learners/components/teams-member-list/components'
import { Icon } from '@iconify/react'
import { Tooltip, Typography } from '@material-ui/core'
/**
 *
 * @param {*} dispatch
 * @param {*} refresh
 */

const columns = [
  {
    attribute: 'name',
    label: 'Name',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    renderer: null,
    width: '45%',
  },

  {
    attribute: 'email',
    label: 'Email',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    renderer: null,
    width: '45%',
  },
  {
    attribute: '',
    label: '',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    renderer: entity => {
      const collectionNames = entity?.collectionNames
      if (!collectionNames || collectionNames.length === 0) {
        return null
      }
      return (
        <Tooltip title={collectionNames.join(', ')} placement="bottom">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              cursor: 'pointer',
              backgroundColor: '#F4F6F8',
              borderRadius: '6px',
              padding: '4px 8px',
            }}
          >
            <Icon
              icon={'solar:user-outline'}
              style={{ width: '16px', height: '16px', color: '#002E47' }}
            />
            <Typography
              variant="body1"
              style={{ fontSize: 13, color: '#002E47' }}
            >
              Info
            </Typography>
          </div>
        </Tooltip>
      )
    },
    width: '5%',
  },
  {
    attribute: '',
    label: null,
    type: ListColumnType.ACTION,
    sortable: false,
    converter: null,
    suffix: null,
    actions: [
      {
        label: 'Edit Learner',
        type: ButtonType.NORMAL,
        link: null,
        exec: (entity, dispatch, refresh) => {
          dispatch(
            componentBoxShowAction(
              new ComponentBoxContent(
                <EditMember entity={entity} dispatch={dispatch} />,
                {
                  hideCloseButton: false,
                },
              ),
            ),
          )
        },
        disabled: entity => {
          return false
        },
        hidden: entity => {
          return false
        },
      },
      {
        label: 'Delete Learner',
        type: ButtonType.NORMAL,
        link: null,
        exec: (entity, dispatch, refresh) => {
          dispatch(
            componentBoxShowAction(
              new ComponentBoxContent(
                <DeleteMember entity={entity} dispatch={dispatch} />,
                {
                  hideCloseButton: false,
                },
              ),
            ),
          )
        },
        disabled: entity => {
          return false
        },
        hidden: entity => {
          return false
        },
      },
    ],
  },
]

export default columns
